module.exports = __webpack_public_path__ + "static/g-6-8e6ab3b37c64cf9f2f5556a23f500737.jpg";